import 'datatables.net-dt/css/jquery.dataTables.css';

//import './dataTables.cellEdit.js';

import React, {Component} from 'react';
import swal from 'sweetalert';
import moment from 'moment';
import {translate} from 'react-i18next';
import readXlsxFile from 'read-excel-file';
import {Table} from 'react-bootstrap';
import RaisedButton from 'material-ui/RaisedButton';
import ModalError from './modalError';
import Help from '../../generics/help';
import { analiticalTestValues, biometricsOption, bloodComponent, donationTypeExtraction, healthFacilitiesOption, unitEntriesMultiple } from '../../../libs/services';

const Config = require('../../../config');

const $ = require('jquery');
//$.DataTable = require('datatables.net-dt');
require('../../../assets/dataTables.cellEdit.js');


class Initial extends Component{
	constructor(props){
		super(props);

		this.onLoad = this.onLoad.bind(this);
		this.myCallbackFunction = this.myCallbackFunction.bind(this);
		this.onSave = this.onSave.bind(this);
		this.addRow = this.addRow.bind(this);
		this.loadTable = this.loadTable.bind(this);
		this.onReturn = this.onReturn.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.getLectina = this.getLectina.bind(this);

		this.state = {
			listado:[],
			columns:[
				{title:'F. DONACIÓN'},
				{title:'T. EXTRACCIÓN'},
				{title:'NO. UNIDAD'},
				{title:'COMPONENTE'},
				{title:'NO. COMPONENTE'},
				{title:'GRUPO'},
				{title:'RH'},
				{title:'LECTINA'},
				{title:'DU'},
				{title:'VOL'},
				{title:'F. CADUCIDAD'},
				{title:'NOMBRE'},
				{title:'A. PATERNO'},
				{title:'A. MATERNO'},
				{title:'HEMOGLOBINA'},
				{title:'HEMATOCRITO'},
				{title:'OBSERVACIONES'},
				{title:''}
			],
			biometrics:[],
			errores:[],
			lectinas:[],
			du_list:[],
			components:[],
			health_facilities:[],
			extraction_types:[],
			health_id:""
		}
	}

	async componentDidMount(){
		var response = await healthFacilitiesOption('distribution');
		if(response !== undefined && response !== null){				
			this.setState({
				health_facilities:response,
			});
		}

		response = await donationTypeExtraction("actives");
		if(response !== undefined){
			var extraction = [];
			extraction.push({value:'', display:''});
			response.map((c)=>{
				extraction.push({
					value:c.id,
					display:c.donation_type_process
				})
			})
			this.setState({
				extraction_types: extraction
			});
		}

		this.getLectina('LECTINA');		

		response = await analiticalTestValues('DU');
		if(response !== undefined && response !== null){
			var du = [];
			du.push({value:'', display:''});
			response.map((d)=>{
				du.push({
					value:d === 'POSITIVO' ? 'POS' : 'NEG',
					display:d === 'POSITIVO' ? 'POS' : 'NEG'
				})
			})
			this.setState({
				du_list:du,
			});
		}

		response = await bloodComponent('actives');
		if(response !== undefined){
			var comp = [];
			comp.push({value:'', display:''});
			response.map((c)=>{
				comp.push({
					value:c.component.code,
					display:c.component.code
				})
			})
			this.setState({
				components:comp,
			});
		}

		response = await biometricsOption('biometrics_for_entry_units');
		if(response !== undefined){
			this.setState({biometrics:response});

			response.map((res)=>{
				if(res.name === this.state.columns[15].title){
					this.state.columns[15].title = res.code;
				}

				if(res.name === this.state.columns[16].title){
					this.state.columns[16].title = res.code;
				}

			})

			this.forceUpdate();
		}

		this.loadTable();
	}

	async getLectina(code){
		var response = await analiticalTestValues(code);
		if(response !== undefined && response !== null && response.length > 0){
			var lect = [];
			lect.push({value:'', display:''});
			response.map((l)=>{
				lect.push({
					value:l,
					display:l
				})
			})
			this.setState({
				lectinas:lect,
			});
		}else{
			if(code !== 'LECTINA'){
				this.getLectina('LECTINA');
			}
		}			
	}

	handleChange(e){
		this.setState({[e.target.name]: e.target.value});

		if(e.target.value !== ""){
			document.getElementById('health_id').classList.remove('error');
		}
	}

	onLoad(){
		const carga = document.getElementById('carga');
		var columns = [], listado = [];
		this.setState({listado:[], errores:[]});

		if(carga.files[0] !== undefined){
			if(carga.files[0].name.indexOf('xlsx') !== -1){

				readXlsxFile(carga.files[0]).then((rows) => {
			    	// `rows` is an array of rows
			    	// each row being an array of cells.
			  
			    	rows.map((row, i)=>{
			    		if(i > 0){
			    			var obj = []
			    			if(row.length === 17){
			    				row.map((r, j)=>{
				    				if(j === 0 || j === 10){
				    					obj.push(r === null ? '' : moment(r).format('DD/MM/YYYY'))
				    				}else{
				    					obj.push(r === null ? '' : r)
				    				}
				    				
				    			})
				    			/*if(typeof obj[1] === 'string'){
				    				if(obj[1].toUpperCase() === 'ALTRUISTA'){*/
				    					obj.push('');
					    				listado.push(obj);
					    			/*}
				    			}*/
			    			}
				    			
			    		}else{
			    			row.map((r)=>{
			    				columns.push({title:r});
			    			})
				    			
			    		}
			    	})		
  	
			  	})

			  	this.loadTable();

			  	this.setState({listado:listado});
			}else{
				swal('Error', 'Formato de archivo no valido, el formato valido es .xlsx', 'error');
				this.loadTable();

			  	this.setState({listado:listado});
			}
		}else{
			swal('Error', 'No se ha cargado ningun archivo', 'error');
		}
	}

	loadTable(){
		setTimeout(()=>{
			this.props.waiting.handleShow('Cargando...');
			this.$el = $(this.el);
		}, 500);

		setTimeout(()=>{
			if(this.$el.attr('class').indexOf('dataTable') !== -1){
				this.$el.DataTable().destroy();
				this.$el.empty();
			}
			this.props.waiting.handleClose();
			this.setTable();
		}, 1000);
	}

	setTable(){
		
		var table = this.$el.DataTable({
			data: this.state.listado,
			columns:this.state.columns,
			oLanguage:{
				"sProcessing":"Procesando...",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"fnInfoCallback":null,
			},
			paging:false,
			responsive:true,
			searching: false,
			scrollX: false,
			autoWidth: false,
			info:false,
			ordering:false,
			createdRow: (row, data, dataIndex)=>{
                if(data[data.length - 1] === "error"){
                	$('td:eq('+(data.length - 1)+')', row).html(
                		'<i style="color:red;font-size:15px;cursor:pointer" '+
                			'unit_id="'+data[2]+'" class="fas fa-times reg-error" ></i>'
                	);
                }else if(data[data.length - 1] === "correcto"){
                	$('td:eq('+(data.length - 1)+')', row).html(
                		'<i style="color:green;font-size:15px" class="fas fa-check reg-correcto"></i>'
                	);
                }else if(data[0] === ''){
                	
                	setTimeout(()=>{
                		if(($('.dataTable tbody tr').length - 1) === dataIndex){
                			/*$('td:eq(0)', row).html(
		                		"<input id='ejbeatycelledit' onfocusout='$(this).updateEditableCell(this)' "+
		                			"value='"+this.state.health_id+"'  style='width:3em;' />"
		                	);*/
                			$('#ejbeatycelledit').focus();
	                		//$('#ejbeatycelledit').parent('td').css({'padding-top':'0'},{'padding-bottom':'0'});
                		}
	                		
                	}, 300)
                }else{
                	$('td:eq('+(data.length - 1)+')', row).html('');
                }
            }
		});

		var errores = this.state.errores;
		$(document).off('click').on('click', '.reg-error', function(){
			var val = $(this).attr('unit_id');

			var index = errores.findIndex(obj =>
				obj.unit_number === val
			);

			if(index !== -1){
				openModal([errores[index]]);
			}
		})

		const openModal = (item)=>{
			this.modal_error.handleShow(item, 'Detalle de error');
		}

		if(this.state.listado.length > 0){
			table.MakeCellsEditable({
		        "onUpdate": this.myCallbackFunction,
		        "inputTypes": [
		        	/*{
		        		"column":0,
		        		"inputClass":'ini-origen',
		        		"type":""
		        	},*/
	            	{
		                "column": 0,
		                "type": "date",
					},
					{
						"column":1,
						"type":"list",
						"inputClass":"extraction-types",
						"options":this.state.extraction_types
					},
	            	/*{
		        		"column":1,
		        		"inputClass":'ini-t-donation',
		        		"type":""
		        	},
		        	/*{
		        		"column":2,
		        		"inputClass":'ini-n-unit',
		        		"type":""
		        	},*/
	            	{
	            		"column": 3,
	            		"type": "list",
	            		"options": this.state.components
	            	},
		        	{
		        		"column":4,
		        		"inputClass":'ini-n-comp',
		        		"type":""
		        	},
	            	{
	            		"column": 5,
	            		"type": "list",
	            		"options": [{value:'', display:''},
	            					{value:'A', display:'A'},
	            					{value:'AB', display:'AB'},
	            					{value:'B', display:'B'},
	            					{value:'O', display:'O'}]
	            	},
	            	{
	            		"column": 6,
	            		"type": "list",
	            		"options": [{value:'', display:''},
	            					{value:'POS', display:'POS'},
	            					{value:'NEG', display:'NEG'}]
	            	},
	            	{
	            		"column": 7,
	            		"type": "list",
	            		"options": this.state.lectinas
	            	},
	            	{
	            		"column": 8,
	            		"type": "list",
	            		"options": this.state.du_list
	            	},
		        	{
		        		"column":9,
		        		"inputClass":'ini-vol',
		        		"type":""
		        	},
	            	{
		                "column": 10,
		                "type": "date", 
	            	},
	            	{
		        		"column":14,
		        		"inputClass":'ini-hb',
		        		"type":""
		        	},
		        	{
		        		"column":15,
		        		"inputClass":'ini-hto',
		        		"type":""
		        	},

	        	],
	        	//"inputCss":'form-control',
	        	"columns": [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16],
		    });
		} 
	}

	myCallbackFunction (updatedCell, updatedRow, oldValue) {
		var index = updatedRow.index();

		this.state.listado[index] = updatedRow.data();
	
		this.forceUpdate();
    }

    async onSave(){
    	if(this.validateTable()){
    		var listado = [];

    		this.state.listado.map((l)=>{
    			var donation_date = moment(l[0], 'DD/MM/YYYY');
				var caducidad = moment(l[10], 'DD/MM/YYYY');

				var index = this.state.extraction_types.findIndex(item => item.display === l[1]);
				
    			var obj = {
    				health_facilities_id:parseInt(sessionStorage.getItem('health_facilities_id'), 10),
    				origin_id: this.state.health_id,
    				donation_date: donation_date.format('MM-DD-YYYY'),
					donation_type_extraction_id: index !== -1 ? this.state.extraction_types[index].value : '',
					unit_number: l[2],
    				component:l[3],
    				component_number:l[4],
    				group:l[5],
    				rh:l[6] === 'POS' ? 'POSITIVO' : l[6] === 'NEG' ? 'NEGATIVO' : '',
    				lectina:l[7],
    				du:l[8] === 'POS' ? 'POSITIVO' : l[8] === 'NEG' ? 'NEGATIVO' : '',
    				volume:l[9],
    				caducidad: l[10] !== "" ? caducidad.format('MM-DD-YYYY') : '',
    				names:l[11],
    				lastname1:l[12],
    				lastname2:l[13],
    				observations:l[16],
    				unit_entries_has_biometrics:[]
    			};
			
				var biometrics = [];
				this.state.biometrics.map((item)=>{
					var bio = this.state.columns.findIndex(obj =>
						obj.title.toUpperCase() === item.name.toUpperCase()
					);
					
					if(bio !== -1){
						biometrics.push({
							biometrics_id: parseInt(item.id, 10),
							value: l[bio],
						});
					}
						
				});

				obj.unit_entries_has_biometrics = biometrics;

				if(l[17] === '' || l[17] === 'error'){
					listado.push(obj);
				}
					
    		})

			var response = await unitEntriesMultiple(listado, this.props.waiting, 'POST');
			if(response !== undefined){
				if(response.length > 0){
				
					this.state.listado.map((list)=>{
						var res = response.findIndex(obj => 
							obj.unit_number === list[2].toString() && obj.component === list[3].toString()
						)

						if(res === -1){
							list[17] = 'correcto';
						}else{
							list[17] = 'error';
						}
					})

					this.setState({errores:response});
					this.modal_error.handleShow(response, 'Hubo un error al cargar los registros');
					//swal('Alerta', 'Hubo un error al cargar los registros', 'warning');
					this.loadTable();

				}else{
					swal('Correcto', 'Los datos se cargaron correctamente', 'success');

					this.setState({listado:[]});

					this.loadTable();
				}

			}
    	}
    }

    validateTable(){
    	var requerido = true;
    	var altruista = true;
    	var vacio = false;
    	$('.dataTable tbody tr').each(function(j){
    		$(this).children('td').each(function(i){
    			switch(i){
    				case 0:
					case 1:
    				case 2:
    				case 3:
    				case 5:
    				case 6: 
    				case 9:
    				case 11:
    				case 12:
    					if($(this).text() === ''){
    						$(this).addClass('danger');
    						requerido = false;
    					}else if($(this).text() === 'Ningún dato disponible en esta tabla'){
    						vacio = true;
    					}else{
    						$(this).removeClass('danger');
    						
    					}
    					break;
    			}
    		})
			
		})

		if(this.state.health_id === ""){
			document.getElementById('health_id').classList.add('error');
			requerido = false;
		}else{
			document.getElementById('health_id').classList.remove('error');
		}

		if(vacio){
			swal('Error', 'No existen datos por cargar', 'error');
		}else if(!altruista){
    		swal('Error', 'El tipo de donación debe ser unicamente altruista', 'error');
    	}else if(!requerido){
    		swal('Error', 'Campos incompletos', 'error');
    	}else if(requerido && altruista){
			return true;
		}
    }

    addRow(){
    	if(this.state.health_id !== ""){
    		var listado = [];
	    	this.state.columns.map((c, i)=>{
	    		if(i === 4){
	    			listado.push('00');
	    		}else{
	    			listado.push('');
	    		}
	    		
	    	})

	    	this.loadTable();

	    	if(this.state.listado.length > 0){
	    		this.setState({
		    		listado:[...this.state.listado, listado]
		    	});
	    	}else{
	    		this.setState({
		    		listado:[listado]
		    	});
	    	}	   
    	}else{
    		swal('Error', 'Campos incompletos', 'error');
    		document.getElementById('health_id').classList.add('error');
    	}
	    	 		
    }

    onReturn(){
    	this.props.history.push('/');
    }

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.distribution.MAIN')} ->
						Carga Inicial
					</h5>
				</div>

				<Help 
					{...this.props}
	                menu={"help_distribution"} 
	                submenu={"help_load_init"}  />
	                
				<div className="col-xs-12 form-group">
					<div className="col-xs-12 col-sm-3" style={{marginTop:'18px'}}>
						<input type="file" id="carga" name="carga" />
					</div>
					<div className="col-xs-12 col-md-2">
						<span>Origen</span>
		                <select className="form-control" name="health_id" id="health_id" value={this.state.health_id || ""}
		                  	onChange={this.handleChange}>
		                  	<option value="">Seleccionar...</option>
			                {this.state.health_facilities.map((s, i)=>(
			                    <option key={i} value={s.id}>{s.name}</option>
			                ))}
		                </select>
		            </div>
					<div className="col-xs-12 col-sm-2" style={{marginTop:'18px'}}>
						<button className="btn btn-info" onClick={this.onLoad}>Carga</button>
					
						<button className="btn btn-info" style={{marginLeft:'10px'}} onClick={this.addRow}>Nueva fila</button>
					</div>
				</div>

				<div className="col-xs-12" id="table-to-pdf">
					<div >
						<table style={{fontSize:"10px"}} className={"table load-file"} id="table-xls" width="100%" ref={el => this.el = el}>
						</table>
					</div>
				</div>
				<div className="col-xs-12" style={{textAlign:'center'}}>
	        		<RaisedButton className="action-btn" label={t('content.generics.buttons.save')} primary={true} onClick={this.onSave}  style={{margin:12}}/>
	        		<RaisedButton className="action-btn" label={t('content.generics.buttons.return')} primary={true} style={{margin:12}} onClick={this.onReturn}/>
	        	</div>
				
				<ModalError {...this.props} onRef={ref => this.modal_error = ref} />
			</div>
		)
	}
}

export default translate('translations')(Initial);